var windows = {"popover":"_popover_mpjyc_1"};

export { windows as default };
